// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetCustomFieldsRequestModel from '../../model/get-custom-fields-request-model';
import GetCustomFieldsRequestDTO from '../dto/get-custom-fields-request-dto';

export default abstract class GetCustomFieldsRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetCustomFieldsRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  'id'?: number;

  static toModel(dto: DeepPartial<GetCustomFieldsRequestDTO>): GetCustomFieldsRequestModel;
  static toModel(dto: DeepPartial<GetCustomFieldsRequestDTO> | undefined | null): GetCustomFieldsRequestModel | undefined;
  static toModel(dto: DeepPartial<GetCustomFieldsRequestDTO> | undefined | null): GetCustomFieldsRequestModel | undefined {
    return dto ? new GetCustomFieldsRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetCustomFieldsRequestModel> | GetCustomFieldsRequestModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'id': unwrapped.id,
    } as GetCustomFieldsRequestDTO;
  }
}
